/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'md2/toast/toast';
import * as import2 from '@angular/common';
import * as import3 from 'md2/core/overlay/position/overlay-position-builder';
import * as import4 from 'md2/core/overlay/overlay';
import * as import5 from 'md2/core/overlay/overlay-container';
import * as import6 from 'md2/core/overlay/scroll/scroll-dispatcher';
import * as import7 from 'md2/core/overlay/position/viewport-ruler';
import * as import8 from './toast.css.ngstyle';
class Md2ToastModuleInjector extends import0.ɵNgModuleInjector<import1.Md2ToastModule> {
  _CommonModule_0:import2.CommonModule;
  _Md2ToastModule_1:import1.Md2ToastModule;
  __NgLocalization_2:import2.NgLocaleLocalization;
  __OverlayContainer_3:any;
  __ScrollDispatcher_4:any;
  __ViewportRuler_5:any;
  __OverlayPositionBuilder_6:import3.OverlayPositionBuilder;
  __Overlay_7:import4.Overlay;
  __Md2ToastConfig_8:import1.Md2ToastConfig;
  __Md2Toast_9:import1.Md2Toast;
  constructor(parent:import0.Injector) {
    super(parent,[Md2ToastComponentNgFactory],([] as any[]));
  }
  get _NgLocalization_2():import2.NgLocaleLocalization {
    if ((this.__NgLocalization_2 == null)) { (this.__NgLocalization_2 = new import2.NgLocaleLocalization(this.parent.get(import0.LOCALE_ID))); }
    return this.__NgLocalization_2;
  }
  get _OverlayContainer_3():any {
    if ((this.__OverlayContainer_3 == null)) { (this.__OverlayContainer_3 = import5.OVERLAY_CONTAINER_PROVIDER_FACTORY(this.parent.get(import5.OverlayContainer,(null as any)))); }
    return this.__OverlayContainer_3;
  }
  get _ScrollDispatcher_4():any {
    if ((this.__ScrollDispatcher_4 == null)) { (this.__ScrollDispatcher_4 = import6.SCROLL_DISPATCHER_PROVIDER_FACTORY(this.parent.get(import6.ScrollDispatcher,(null as any)),this.parent.get(import0.NgZone))); }
    return this.__ScrollDispatcher_4;
  }
  get _ViewportRuler_5():any {
    if ((this.__ViewportRuler_5 == null)) { (this.__ViewportRuler_5 = import7.VIEWPORT_RULER_PROVIDER_FACTORY(this.parent.get(import7.ViewportRuler,(null as any)),this._ScrollDispatcher_4)); }
    return this.__ViewportRuler_5;
  }
  get _OverlayPositionBuilder_6():import3.OverlayPositionBuilder {
    if ((this.__OverlayPositionBuilder_6 == null)) { (this.__OverlayPositionBuilder_6 = new import3.OverlayPositionBuilder(this._ViewportRuler_5)); }
    return this.__OverlayPositionBuilder_6;
  }
  get _Overlay_7():import4.Overlay {
    if ((this.__Overlay_7 == null)) { (this.__Overlay_7 = new import4.Overlay(this._OverlayContainer_3,this.componentFactoryResolver,this._OverlayPositionBuilder_6,this.parent.get(import0.ApplicationRef),this,this.parent.get(import0.NgZone))); }
    return this.__Overlay_7;
  }
  get _Md2ToastConfig_8():import1.Md2ToastConfig {
    if ((this.__Md2ToastConfig_8 == null)) { (this.__Md2ToastConfig_8 = new import1.Md2ToastConfig()); }
    return this.__Md2ToastConfig_8;
  }
  get _Md2Toast_9():import1.Md2Toast {
    if ((this.__Md2Toast_9 == null)) { (this.__Md2Toast_9 = new import1.Md2Toast(this._Overlay_7,this._Md2ToastConfig_8)); }
    return this.__Md2Toast_9;
  }
  createInternal():import1.Md2ToastModule {
    this._CommonModule_0 = new import2.CommonModule();
    this._Md2ToastModule_1 = new import1.Md2ToastModule();
    return this._Md2ToastModule_1;
  }
  getInternal(token:any,notFoundResult:any):any {
    if ((token === import2.CommonModule)) { return this._CommonModule_0; }
    if ((token === import1.Md2ToastModule)) { return this._Md2ToastModule_1; }
    if ((token === import2.NgLocalization)) { return this._NgLocalization_2; }
    if ((token === import5.OverlayContainer)) { return this._OverlayContainer_3; }
    if ((token === import6.ScrollDispatcher)) { return this._ScrollDispatcher_4; }
    if ((token === import7.ViewportRuler)) { return this._ViewportRuler_5; }
    if ((token === import3.OverlayPositionBuilder)) { return this._OverlayPositionBuilder_6; }
    if ((token === import4.Overlay)) { return this._Overlay_7; }
    if ((token === import1.Md2ToastConfig)) { return this._Md2ToastConfig_8; }
    if ((token === import1.Md2Toast)) { return this._Md2Toast_9; }
    return notFoundResult;
  }
  destroyInternal():void {
  }
}
export const Md2ToastModuleNgFactory:import0.NgModuleFactory<import1.Md2ToastModule> = new import0.NgModuleFactory<any>(Md2ToastModuleInjector,import1.Md2ToastModule);
const styles_Md2ToastComponent:any[] = [import8.styles];
export const RenderType_Md2ToastComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_Md2ToastComponent,
  data: {}
}
);
function View_Md2ToastComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'md2-toast'
      ]
      ],[[
        2,
        'in',
        (null as any)
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.remove(v.context.$implicit.id)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    ))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.isVisible;
    ck(v,0,0,currVal_0);
    const currVal_1:any = v.context.$implicit.message;
    ck(v,1,0,currVal_1);
  });
}
export function View_Md2ToastComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_Md2ToastComponent_1)),
    import0.ɵdid(802816,(null as any),0,import2.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:import1.Md2ToastComponent = v.component;
    const currVal_0:any = co.toasts;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_Md2ToastComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'md2-toast',([] as any[]),(null as any),(null as any),(null as any),View_Md2ToastComponent_0,RenderType_Md2ToastComponent)),
    import0.ɵdid(49152,(null as any),0,import1.Md2ToastComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const Md2ToastComponentNgFactory:import0.ComponentFactory<import1.Md2ToastComponent> = import0.ɵccf('md2-toast',import1.Md2ToastComponent,View_Md2ToastComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvbm9kZV9tb2R1bGVzL21kMi90b2FzdC90b2FzdC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92ZXJjZWwvd29ya3BhdGgwL25vZGVfbW9kdWxlcy9tZDIvdG9hc3QvdG9hc3QuZC50cyIsIm5nOi8vL3ZlcmNlbC93b3JrcGF0aDAvbm9kZV9tb2R1bGVzL21kMi90b2FzdC90b2FzdC5odG1sIiwibmc6Ly8vdmVyY2VsL3dvcmtwYXRoMC9ub2RlX21vZHVsZXMvbWQyL3RvYXN0L3RvYXN0LmQudHMuTWQyVG9hc3RDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2ICpuZ0Zvcj1cImxldCB0b2FzdCBvZiB0b2FzdHNcIiBjbGFzcz1cIm1kMi10b2FzdFwiIFtjbGFzcy5pbl09XCJ0b2FzdC5pc1Zpc2libGVcIiAoY2xpY2spPVwicmVtb3ZlKHRvYXN0LmlkKVwiPnt7IHRvYXN0Lm1lc3NhZ2UgfX08L2Rpdj4iLCI8bWQyLXRvYXN0PjwvbWQyLXRvYXN0PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7TUNBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7TUFBQTtNQUFpRjtRQUFBO1FBQUE7TUFBQTtNQUFqRjtJQUFBO0lBQTRHO01BQUE7TUFBQTtJQUFBO0lBQUE7OztJQUF4RDtJQUFwRCxTQUFvRCxTQUFwRDtJQUE0RztJQUFBOzs7OztJQUE1RztnQkFBQTs7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTs7OztJQUFLO0lBQUwsU0FBSyxTQUFMOzs7OztJQ0FBO2dCQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/~/md2/toast/toast.ngfactory.ts